/* CS-78 — Mengen-Stepper Verhalten (Event-Delegation, wirkt auch in AJAX-Modals). CSS liegt in cellini-qty.css (im <head>). */
(function(){
  if (window.__cnQtyInit) return; window.__cnQtyInit = 1;
  function clamp(inp){
    var min=parseInt(inp.getAttribute('min'),10); if(isNaN(min))min=1;
    var max=parseInt(inp.getAttribute('max'),10);
    var v=parseInt(inp.value,10); if(isNaN(v))v=min;
    if(v<min)v=min; if(!isNaN(max)&&v>max)v=max;
    inp.value=v; return v;
  }
  document.addEventListener('click', function(e){
    var b=e.target.closest('.cn-qty__btn'); if(!b) return;
    e.preventDefault();
    var box=b.closest('.cn-qty'); if(!box) return;
    var inp=box.querySelector('.cn-qty__input'); if(!inp) return;
    var step=parseInt(b.getAttribute('data-cn-step'),10)||0;
    inp.value=(parseInt(inp.value,10)||1)+step;
    clamp(inp);
    inp.dispatchEvent(new Event('change',{bubbles:true}));
  });
  document.addEventListener('change', function(e){
    if(e.target && e.target.classList && e.target.classList.contains('cn-qty__input')) clamp(e.target);
  });
})();
